/**
 * Created by USER on 18/6/12.
 */
import {GET_BLOG, GET_SINGLE_BLOG} from '../actions/blog_action';
import {getBlog} from '../actions/blog_action';

const initState = {
  blogData: [],
  singleData: {}
};

export default function blogReducer(state = initState, action) {
  switch (action.type) {
    case GET_BLOG:
      return Object.assign({}, state, { blogData: action.data});
    case GET_SINGLE_BLOG:
      return Object.assign({}, state, { singleData: action.data});
    default:
      return state;
  }
}

// export function fetchBlogData() {
//   return fetch(`http://localhost:2046/blog`, {
//     method: 'GET',
//     mode: 'cors',
//     credentials: 'same-origin'
//   }).then((res) => {
//   }, () => {
//   }).then(() => {
//   });
// }

// export function fetchSingleBlogData(id) {
//   return fetch(`http://localhost:2046/blog/${id}`, {
//     method: 'GET',
//     mode: 'cors',
//     credentials: 'same-origin'
//   }).then((res) => {
//   }, () => {
//   }).then(() => {
//   });
// }
